import { useRef, useState } from 'react';

import { inRn } from 'lib/helpers/utility';
import { resolveTipPercentages } from 'lib/constants/transaction/tips';

import { usePaymentContext, usePaymentContextApi } from '../context/PaymentContext';

export const useTipPrompt = ({ displaySettings, presetTip = 0 }) => {
  const isEnabled = !!displaySettings?.allow_tips;
  const { values } = usePaymentContext();
  const { setFieldValue } = usePaymentContextApi();
  const [isOpen, setIsOpen] = useState(false);
  const continueRef = useRef(null);
  const appliedRef = useRef(null);

  const amount = inRn(values?.amount);
  const currentTip = appliedRef.current?.amount === amount ? appliedRef.current.tip : 0;
  const amountBeforeTip = amount - currentTip;
  const baseAmount = Math.max(0, amountBeforeTip - inRn(values?.surchargeAmount));

  const canTip = amountBeforeTip > 0 && !values?.recurringPayment && !values?.tokenOnly;
  const staffTip = Math.max(Math.round(inRn(presetTip)), 0);
  const hasStaffTip = canTip && staffTip > 0;
  const isTippable = isEnabled && canTip;

  const promptTip = (onContinue) => {
    if (hasStaffTip) {
      continueRef.current = onContinue;
      applyTip(staffTip);
      return;
    }
    if (!isTippable) {
      onContinue();
      return;
    }
    continueRef.current = onContinue;
    setIsOpen(true);
  };

  const applyTip = (tip) => {
    const nextTip = inRn(tip);
    const nextAmount = amountBeforeTip + nextTip;
    appliedRef.current = { tip: nextTip, amount: nextAmount };
    setFieldValue('gratuity', nextTip);
    setFieldValue('amount', nextAmount);

    const onContinue = continueRef.current;
    continueRef.current = null;
    onContinue?.();
  };

  return {
    promptTip,
    tipModalProps: {
      isOpen,
      onClose: () => setIsOpen(false),
      baseAmount,
      currentGratuity: currentTip,
      onApply: applyTip,
      percentages: resolveTipPercentages(displaySettings)
    }
  };
};
